import { SIGN_IN_EVENT } from '~/common/constants'
import { logClickEvent, logDefaultActionEvent } from '~/common/tracking/event-client.tracking'
import { notifyStore } from '~/stores'

export const handleGraphQLError = (graphQLErrors, email) => {
	const error = graphQLErrors?.[0]?.extensions?.error
	logDefaultActionEvent(SIGN_IN_EVENT.SIGNIN_SUBMIT_FAILED, { email })

	const notifyError = (message, options = {}) => {
		if (message) notifyStore.error(message, { keepOriginal: true, ...options })
	}

	switch (error) {
		case 'temp_password_expired':
			notifyError(
				`<span>
					The password you entered has expired and is only valid for <strong style="color:#333335;">72 hours.</strong>
					<br />
					We have sent a new temporary password to your email. Please check it and follow the instructions to reset your password.
				</span>`,
				{
					title: 'Temporary password expired',
					okText: 'I got it',
					showDialog: true,
				}
			)
			break
		case 'wrong_username_or_password_error':
			const attemptsRemaining = 5 - (graphQLErrors?.[0]?.extensions?.failed_attempts || 0)
			notifyError(`You have ${attemptsRemaining} attempts remaining. After 5 failed attempts, your account will be temporarily locked.`, {
				title: 'Log in error',
				okText: 'TRY_AGAIN',
				showDialog: true,
				onOk: (key) => {
					logClickEvent(SIGN_IN_EVENT.CLICK_TRY_AGAIN_BTN)
					notifyStore.closeDialog(key)
				},
				isShowOkText: false,
			})
			break
		case 'locked_access_error':
			notifyError('Your account is now temporarily locked. Please check your email for the unlock instructions.', {
				title: 'You have failed to sign in 5 times',
				okText: 'I got it',
				showDialog: true,
				onOk: (key) => {
					logClickEvent(SIGN_IN_EVENT.CLICK_I_GOT_IT_BTN)
					notifyStore.closeDialog(key)
				},
			})
			break
		default:
			notifyError(error?.message)
			break
	}
}
